import { useRef, useState } from 'react';
import { Upload } from 'lucide-react';
import { Banner } from './ModalShell';
import { ACCEPTED_TYPES, PRIMARY_BUTTON, MICRO_LABEL } from './constants';



const UploadStep = ({ onPhotoReady }) => {
    const fileInputRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [error, setError] = useState(null);

    const handleFile = (file) => {
        setError(null);
        if (!file) return;

        if (!ACCEPTED_TYPES.includes(file.type)) {
            setError('Please choose a JPG or PNG photo.');
            return;
        }

        const reader = new FileReader();
        reader.onload = (e) => onPhotoReady(e.target?.result);
        reader.onerror = () => setError("We couldn't read that file. Please try another photo.");
        reader.readAsDataURL(file);
    };

    return (
        <div>
            {error && <Banner>{error}</Banner>}

            <input
                ref={fileInputRef}
                type="file"
                accept="image/jpeg, image/jpg, image/png"
                className="hidden"
                onChange={(e) => handleFile(e.target.files?.[0])}
            />

            <div
                onClick={() => fileInputRef.current?.click()}
                onDragOver={(e) => { e.preventDefault(); setIsDragging(true); }}
                onDragLeave={() => setIsDragging(false)}
                onDrop={(e) => {
                    e.preventDefault();
                    setIsDragging(false);
                    handleFile(e.dataTransfer.files?.[0]);
                }}
                className={`border-2 border-dashed rounded-xl flex flex-col items-center justify-center px-6 py-12 cursor-pointer select-none transition-colors ${isDragging
                    ? 'border-[#38433A] bg-[#F0F4F1]'
                    : 'border-[#D4D0CB] hover:border-[#38433A] hover:bg-[#FAFAF9]'
                    }`}
            >
                <div className="w-[52px] h-[52px] rounded-full bg-[#F5F3F0] flex items-center justify-center mb-4">
                    <Upload className="w-5 h-5 text-[#38433A]" />
                </div>
                <p className="text-[15px] text-[#2D2D2D] text-center mb-1">Drop a photo or click to browse</p>
                <p className="text-[13px] text-[#939393] text-center">JPG or PNG — portrait photos work best</p>
            </div>

            <button type="button" onClick={() => fileInputRef.current?.click()} className={`mt-3 ${PRIMARY_BUTTON}`}>
                <Upload className="w-3.5 h-3.5" />
                <span className={MICRO_LABEL}>Choose Photo</span>
            </button>
        </div>
    );
};

export default UploadStep;
